/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function o(o){return o.locationsMap}const t={color:{write:[!0,!0,!0,!0],blendMode:"composite"},depth:!1,stencil:!1};export{o as getLocations,t as simplePipelineState};
